import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import useQueryAdvertisement from '../../../hooks/api/advertisement/useQueryAdvertisement'
import {IAdvertisement} from '../../../apis/advertisement/getAdvertisement'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'
import TableHeader from '../../../components/table/TableHeader'
import Text from '../../../components/text/Text'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import WizImage from '../../../components/image/WizImage'
import {useTime} from '../../../utils/time'
import WizTag from '../../../components/tag/WizTag'

interface IProps {
    className?: string
}

const AdvertisementPage: React.FC<IProps> = ({className}) => {
    const {goAdvertisementCreate, goAdvertisementDetail} = useNavigation()
    const {localTimeString} = useTime()

    const [currentPage, setCurrentPage] = useState(1)

    const {data, refetch} = useQueryAdvertisement()

    const advertisementList = useMemo(() => {
        const list: IAdvertisement[] = []
        data?.data?.map(item => list.push(item))
        list?.sort(value => (value.is_active ? -1 : 1))
        return list
    }, [data])

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <PageLayout title={'Advertisement'} className={className}>
            <WizButton text={'Create AD'} type={'primary'} onClick={goAdvertisementCreate} />

            <TableHeader className={'grid-cols-[60px_auto_100px_220px_120px] mt-[30px] space-x-[20px] md:hidden'}>
                <Text>Image</Text>
                <Text>Title / Content</Text>
                <Text className={'text-center'}>Channel</Text>
                <Text>Create At</Text>
                <Text>Active</Text>
            </TableHeader>

            <TableLayout>
                {advertisementList?.map(item => (
                    <TableItem
                        className={
                            'grid-cols-[60px_auto_100px_220px_120px] space-x-[20px] md:space-x-0 md:grid-cols-3 md:items-start sm:px-[0px]'
                        }
                        onClick={() => goAdvertisementDetail(item?.id)}>
                        <div className={'md:col-span-3'}>
                            {item?.thumbnail ? (
                                <WizImage
                                    src={`${item?.thumbnail}`}
                                    className={'w-[40px] h-[40px] rounded-full md:mx-auto'}
                                />
                            ) : (
                                <div className={'w-[40px] h-[40px] rounded-full border border-line02 bg-bg_gray01'}>
                                    <Text className={'text-body_comm text-font03 text-center leading-[38px]'}>
                                        Image
                                    </Text>
                                </div>
                            )}
                        </div>

                        <div className={'space-y-[5px] md:col-span-3 md:text-center md:pb-[10px]'}>
                            <Text className={'text-ti2 md:text-ti1'}>{item?.title || '[No Name]'}</Text>
                            <Text className={'text-font03'}>{item?.description || '-'}</Text>
                        </div>
                        <div className={'md:space-y-[5px] md:text-center'}>
                            <Text className={'text-ti3 text-font03 hidden md:block'}>Channel</Text>
                            <Text className={'text-center text-ti1'}>{item?.language.toUpperCase()}</Text>
                        </div>
                        <div className={'md:space-y-[5px] md:text-center'}>
                            <Text className={'text-ti3 text-font03 hidden md:block'}>Date</Text>
                            <Text className={'sm:text-body3 sm:text-font02'}>{localTimeString(item?.created_at)}</Text>
                        </div>
                        <div className={'md:space-y-[5px] md:text-center'}>
                            <Text className={'text-ti3 text-font03 hidden md:block'}>Status</Text>
                            {item?.is_active ? (
                                <WizTag textClassName={'md:mx-auto'} state={true}>
                                    Active
                                </WizTag>
                            ) : (
                                <WizTag textClassName={'md:mx-auto'} state={false}>
                                    DeActive
                                </WizTag>
                            )}
                        </div>
                    </TableItem>
                ))}
            </TableLayout>
        </PageLayout>
    )
}

export default AdvertisementPage
